import React from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";

import { TileForm } from "./tile-form/tile-form";
import { Tile } from "./tile/tile";
import {
  TileDrawerModalObj,
  useTileDrawerModalHook,
} from "./use-tile-drawer-modal-hook";

import styles from "./tile-drawer-modal.module.scss";

interface TileDrawerModalProps {
  useHook?: () => TileDrawerModalObj;
}

const cssClassName = "tile-drawer-modal";

export const TileDrawerModal = ({
  useHook = useTileDrawerModalHook,
}: TileDrawerModalProps) => {
  const {
    buildEmptyTile,
    cancelCreateNewTileForm,
    cancelEditTileForm,
    closeTileDrawerModal,
    createNewTile,
    deleteTile,
    drawerContent,
    loadTileToEdit,
    localTiles,
    saveTile,
    showCreateNewTileForm,
    texts,
    tileToEdit,
  } = useHook();

  return (
    <DrawerModal id={"tileDrawerModal"}>
      <div className={styles[cssClassName]}>
        <p className={styles[`${cssClassName}__headline`]}>{texts.title}</p>
        {drawerContent === "showTilesList" && (
          <div>
            {localTiles &&
              localTiles.map((tile) => (
                <Tile
                  key={tile.id}
                  tile={tile}
                  editCallback={() => {
                    loadTileToEdit(tile.id);
                  }}
                  deleteCallback={() => {
                    deleteTile(tile.id);
                  }}
                />
              ))}
            <button onClick={showCreateNewTileForm}>{texts.create}</button>
            <button onClick={closeTileDrawerModal}>{texts.close}</button>
          </div>
        )}
        {drawerContent === "createNewTile" && (
          <>
            <p>{texts.createNewTile}</p>
            <TileForm
              tile={buildEmptyTile()}
              createCallback={createNewTile}
              cancelCallback={cancelCreateNewTileForm}
            />
          </>
        )}
        {drawerContent === "editTile" && (
          <>
            <p>{texts.editTile}</p>
            <TileForm
              tile={tileToEdit}
              createCallback={saveTile}
              cancelCallback={cancelEditTileForm}
            />
          </>
        )}
      </div>
    </DrawerModal>
  );
};
